var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import minimatch from 'minimatch';
import { castArray, isFunction } from '@ally/utilitarian';
var DATA_ATTRIBUTE_NAME = 'data-app-id';
var STRIP_SLASHES = /^\/|\/$/g;
export var getAppDiv = function (_a) {
    var id = _a.id;
    return document.querySelector("div[" + DATA_ATTRIBUTE_NAME + "=\"" + id + "\"]");
};
export function logsUnmountError(log, mounted) {
    return function (e) {
        log.warn({
            message: ["[UNMOUNT FAILURE] Failed to unmount " + mounted.id + ":", e.stack],
        });
    };
}
/**
 * Converts a record of AppSchema into an App[].
 */
export function toAppArray(apps) {
    return Object.entries(apps).map(function (_a) {
        var _b = __read(_a, 2), id = _b[0], app = _b[1];
        return (__assign(__assign({}, app), { id: id }));
    });
}
/**
 * Given string patterns to match this will retun a new function that
 * will test the given path against those patterns and return true if it matches any
 */
export function matchByPath(match) {
    return function (path) {
        var target = "/" + path.replace(STRIP_SLASHES, '') + "/";
        var matchArray = castArray(match);
        return matchArray.some(function (m) {
            var pattern = m && "/" + m.replace(STRIP_SLASHES, '');
            return pattern && minimatch(target, pattern);
        });
    };
}
/**
 * Returns the App from `apps` that matches `path` per
 * the app's `match` property. If no matching app is found, null is
 * returned.
 */
export function findMatchingApp(apps, path) {
    var _a;
    return ((_a = toAppArray(apps).find(function (_a) {
        var match = _a.match;
        var matchFn = isFunction(match) ? match : matchByPath(match);
        return matchFn(path);
    })) !== null && _a !== void 0 ? _a : null);
}
/**
 * Creates a new `div` for the application to be mounted to, inserts it into
 * the "application container" (target) element, and returns it to be passed
 * to the app module's `mount` method.
 */
export function getAppContainer(_a) {
    var id = _a.id;
    var container = document.createElement('div');
    container.setAttribute(DATA_ATTRIBUTE_NAME, id.toString());
    return container;
}
//# sourceMappingURL=federator.js.map